var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPostReady = function SvgPostReady(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.13,
    cy: 10.13,
    r: 9.13,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7.11 9.26 10.17 6l3.06 3.26M10.24 13.95V6.61",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgPostReady;